import { PasswordButtonComponent } from "./password-button/password-button.component";
import { NgModule } from '@angular/core';
import { NbButtonModule, NbCardModule, NbFormFieldModule, NbIconModule, NbInputModule } from "@nebular/theme";
import { FormsModule } from "@angular/forms";
import { ThemeModule } from "../../@theme/theme.module";
import { InputFileButtonComponent } from './input-file-button/input-file-button.component';

@NgModule({
  imports: [
    ThemeModule,
    NbCardModule,
    NbButtonModule,
    NbIconModule,
    NbInputModule,
    FormsModule,
    NbFormFieldModule,
  ],
  declarations: [
    PasswordButtonComponent,
    InputFileButtonComponent,
  ],
  exports: [
    PasswordButtonComponent,
    InputFileButtonComponent,
  ],
})
export class ButtonsModule { }
